import supabase from '@/supabase/supabase';

export const notificationsService = {
  async getByUser(userId) {
    try {
      const result = await supabase
        .from('notifications')
        .select('id, title, message, is_read, created_at')
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(50);
      return result;
    } catch (err) {
      console.error('getByUser error:', err);
      return { data: [], error: err };
    }
  },

  async getUnreadCount(userId) {
    try {
      const result = await supabase
        .from('notifications')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .eq('is_read', false);
      return result;
    } catch (err) {
      console.error('getUnreadCount error:', err);
      return { count: 0, error: err };
    }
  },

  async markAsRead(notificationId) {
    return supabase
      .from('notifications')
      .update({ is_read: true })
      .eq('id', notificationId);
  },

  async markAllAsRead(userId) {
    return supabase
      .from('notifications')
      .update({ is_read: true })
      .eq('user_id', userId)
      .eq('is_read', false);
  },

  async create(userId, title, message) {
    return supabase
      .from('notifications')
      .insert({ user_id: userId, title, message })
      .select()
      .single();
  },
};